import React, { useState, useEffect } from 'react';
import ProductService from "../Api/ProductService";
import { Input, Form, Col, Divider, Row, Button, DatePicker, Select, Switch } from 'antd';
import {useDispatch, useSelector} from "react-redux";

function CrmProductForm(props) {

    const id = props.id;
    const [form] = Form.useForm();
    const { TextArea } = Input;
    const { Option } = Select;

    console.log(props)
    useEffect(() => {
        if (id) {
           // getProduct(id);
        }
    }, [id])

    useEffect(() => {
        console.log(id)

        if (id) {
            console.log('useEffect-1',id, product)

            const response = getProduct(id);

            console.log('useEffect-2',id, response)
        }
    }, [props.rand])

    const defaultProductData = {
        id: '',
        name: '',
        group_id: '',
        description: '',
        meta_description: '',
        quantity_pack: '',
        barcode: '',
        quantity: '',
        price: '',
        unit: '',
        type_id: '',
        warehouse_id: '',
        manufacturer_id: '',
        comment: '',
        site_on: '',
        code: '',
        status: '',
        user_id: '',
        suitability: '',
    }



    const [product, setProduct] = useState(defaultProductData);
    console.log('defaultProductData', defaultProductData)
    console.log('product', product)
const onFill = () => {
    console.log('onFill-1',id, product)
    form.setFieldsValue({
        id: product.id,
        name: product.name ?? '',
        group_id: product.group_id ?? '',
        description: product.description ?? '',
        meta_description: product.meta_description ?? '',
        quantity_pack: product.quantity_pack ?? '',
        barcode: product.barcode ?? '',
        quantity: product.quantity ?? '',
        price: product.price ?? '',
        unit: product.unit ?? '',
        type_id: product.type_id ?? '',
        warehouse_id: product.warehouse_id ?? '',
        manufacturer_id: product.manufacturer_id ?? '',
        comment: product.comment ?? '',
        site_on: product.site_on ?? '' ,
        code: product.code ?? '',
        status: product.status ?? '',
        user_id: product.user_id ?? '',
        suitability: product.suitability ?? '',

    });

    console.log('onFill-2',id, product)
}

    async function getProduct(id) {
        console.log('getProduct-1',id, product)
        const response = await ProductService.getOne(id);
        console.log('getProduct-2',id, response)
        await form.setFieldsValue({
            id: response.id,
            name: response.name ?? '',
            group_id: response.group_id ?? '',
            description: response.description ?? '',
            meta_description: response.meta_description ?? '',
            quantity_pack: response.quantity_pack ?? '',
            barcode: response.barcode ?? '',
            quantity: response.quantity ?? '',
            price: response.price ?? '',
            unit: response.unit ?? '',
            type_id: response.type_id ?? '',
            warehouse_id: response.warehouse_id ?? '',
            manufacturer_id: response.manufacturer_id ?? '',
            comment: response.comment ?? '',
            site_on: response.site_on ?? '' ,
            code: response.code ?? '',
            status: response.status ?? '',
            user_id: response.user_id ?? '',
            suitability: response.suitability ?? '',
        });
        setProduct({
            id: response.id,
            name: response.name ?? '',
            group_id: response.group_id ?? '',
            description: response.description ?? '',
            meta_description: response.meta_description ?? '',
            quantity_pack: response.quantity_pack ?? '',
            barcode: response.barcode ?? '',
            quantity: response.quantity ?? '',
            price: response.price ?? '',
            unit: response.unit ?? '',
            type_id: response.type_id ?? '',
            warehouse_id: response.warehouse_id ?? '',
            manufacturer_id: response.manufacturer_id ?? '',
            comment: response.comment ?? '',
            site_on: response.site_on ?? '' ,
            code: response.code ?? '',
            status: response.status ?? '',
            user_id: response.user_id ?? '',
            suitability: response.suitability ?? '2000-01-01',
        });
return response;
        console.log('getProduct-3',id, product)

        console.log('getProduct-3_',id, product)
    }



    async function editProduct() {

        const response = await ProductService.edit(product);
        if (response.data.id) {
            console.log(response.data.id);
        } else {
            console.log('error');
        }
    }

    async function addNewProduct(e) {
        e.preventDefault();

        product.suitability = "2022-10-12";
        const response = await ProductService.create(product);

        if (response.data.id) {
            console.log(response.data.id);
        } else {
            console.log('error');
        }

    }
    const onGenderChange = (value) => {
        switch (value) {
            case 'male':
                form.setFieldsValue({
                    note: 'Hi, man!',
                });
                return;
            case 'female':
                form.setFieldsValue({
                    note: 'Hi, lady!',
                });
                return;
            case 'other':
                form.setFieldsValue({
                    note: 'Hi there!',
                });
                break;
            default:
        }
    }
    return (

        <Form form={form} >


                <Divider orientation="left">{product.id}</Divider>
                <Row gutter={16}>
                    <Col className="gutter-row" span={12}>
                        <Form.Item label="Name" name="name"
                                   rules={[{ required: true, message: 'Please input your name!' }]}>
                            <Input onChange={e => setProduct({...product, name: e.target.value})}/>
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={6}>
                        <Form.Item name="gender" label="Gender">
                            <Select allowClear >
                                <Option value="male">male</Option>
                                <Option value="female">female</Option>
                                <Option value="other">other</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={6}>
                        <Form.Item label="Barcode" name="barcode">
                            <Input onChange={e => setProduct({...product, barcode: e.target.value})}/>
                        </Form.Item>
                    </Col>
                </Row>


                <Row gutter={16}>
                    <Col className="gutter-row" span={6}>
                        <Form.Item label="Price" name="price">
                            <Input onChange={e => setProduct({...product, price: e.target.value})}/>
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={6}>
                        <Form.Item label="Quantity" name="quantity">
                            <Input onChange={e => setProduct({...product, quantity: e.target.value})}/>
                        </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={6}>
                        <Form.Item label="Quantity pack" name="quantity_pack">
                            <Input onChange={e => setProduct({...product, quantity_pack: e.target.value})}/>
                        </Form.Item>
                    </Col>

                    <Col className="gutter-row" span={6}>
                        <Form.Item label="Unit" name="unit">
                            <Select onChange={e => setProduct({...product, quantity_pack: e.target.value})}>
                                <Select.Option value="0">-</Select.Option>
                                <Select.Option value="1">Одитиць</Select.Option>
                                <Select.Option value="2">Штук</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>


            <Row gutter={16}>
                <Col className="gutter-row" span={8}>
                    <Form.Item label="Description" name="description">
                        <TextArea rows={4} />
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={8}>
                    <Form.Item label="Meta Description" name="meta_description">
                        <TextArea rows={4} onChange={e => setProduct({...product, meta_description: e.target.value})}/>
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={8}>
                    <Form.Item label="Comment" name="comment">
                        <TextArea rows={4} onChange={e => setProduct({...product, comment: e.target.value})}/>
                    </Form.Item>
                </Col>

            </Row>






            <Row gutter={16}>
                <Col className="gutter-row" span={5}>
                    <Form.Item label="Manufacturer" name="manufacturer_id">
                        <Select onChange={e => setProduct({...product, manufacturer_id: e.target.value})}>
                            <Select.Option value="0">-</Select.Option>
                            <Select.Option value="1">Активне</Select.Option>
                            <Select.Option value="2">Контент</Select.Option>
                            <Select.Option value="3">Вимкнене</Select.Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                    <Form.Item label="Srok gd" name="suitability">
                        <DatePicker onChange={e => setProduct({...product, suitability: e.target.value})} />
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={5}>
                    <Form.Item label="Status" name="status">
                        <Select onChange={e => setProduct({...product, status: e.target.value})}>
                            <Select.Option value="0">-</Select.Option>
                            <Select.Option value="1">Активне</Select.Option>
                            <Select.Option value="2">Контент</Select.Option>
                            <Select.Option value="3">Вимкнене</Select.Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={5}>
                    <Form.Item label="Type" name="type_id">
                        <Select onChange={e => setProduct({...product, type_id: e.target.value})}>
                            <Select.Option value="0">-</Select.Option>
                            <Select.Option value="1">тип 1</Select.Option>
                            <Select.Option value="2">Тип 2</Select.Option>
                            <Select.Option value="3">Тип 3</Select.Option>
                            <Select.Option value="4">Тип 4</Select.Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col className="gutter-row" span={2}>
                    <Form.Item label="On site" name="site_on">
                        <Switch defaultChecked onChange={console.log(213123123)} />
                    </Form.Item>
                </Col>
            </Row>
            {/*


                <input type="text" className="form-control" placeholder="name"
                       value={product.name}
                       onChange={e => setProduct({...product, name: e.target.value})}
                />
                <input type="text" className="form-control" placeholder="description"
                       value={product.description}
                       onChange={e => setProduct({...product, description: e.target.value})}
                />
                <input type="text" className="form-control" placeholder="meta_description"
                       value={product.meta_description}
                       onChange={e => setProduct({...product, meta_description: e.target.value})}
                />
                <input type="text" className="form-control" placeholder="quantity_pack"
                       value={product.quantity_pack}
                       onChange={e => setProduct({...product, quantity_pack: e.target.value})}
                />
                <input type="text" className="form-control" placeholder="barcode"
                       value={product.barcode}
                       onChange={e => setProduct({...product, barcode: e.target.value})}
                />
                <input type="text" className="form-control" placeholder="quantity"
                       value={product.quantity}
                       onChange={e => setProduct({...product, quantity: e.target.value})}
                />
                <input type="text" className="form-control" placeholder="price"
                       value={product.price}
                       onChange={e => setProduct({...product, price: e.target.value})}
                />
                <input type="text" className="form-control" placeholder="unit"
                       value={product.unit}
                       onChange={e => setProduct({...product, unit: e.target.value})}
                />
                <input type="text" className="form-control" placeholder="type_id"
                       value={product.type_id}
                       onChange={e => setProduct({...product, type_id: e.target.value})}
                />
            */}
                {id
                    ?  <Button type="primary" onClick={editProduct}>edit</Button>
                    : <Button type="primary" onClick={addNewProduct}>create</Button>
                }



            </Form>

    );
}

export default CrmProductForm;


